import React from 'react';
import { SeparationType } from '../../enums/SeparationType';
import { ListOrders } from '../ListOrders/ListOrders';

interface IManageOrderBatchProps {
  separationType: SeparationType;
  expressOrder?: boolean;
  listingOrders?: () => void;
}

const ManageOrderBatch: React.FC<IManageOrderBatchProps> = ({
  separationType,
  expressOrder,
  listingOrders
}) => {
  return (
    <ListOrders
      separationType={separationType}
      expressOrder={expressOrder}
      listingOrders={listingOrders}
    />
  );
}

export { ManageOrderBatch };
